/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ConnectionStatus = 'Pending' | 'Verified' | 'None';

export const ConnectionStatus = {
    Pending: 'Pending' as ConnectionStatus,
    Verified: 'Verified' as ConnectionStatus,
    None: 'None' as ConnectionStatus
};